import React from "react";

const BackButtonIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="icon icon-tabler icons-tabler-outline icon-tabler-arrow-back-up-double"
  >
    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
    <path d="M13 14l-4 -4l4 -4" />
    <path d="M8 14l-4 -4l4 -4" />
    <path d="M9 10h7a4 4 0 1 1 0 8h-1" />
  </svg>
);

export default BackButtonIcon;
